import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  currentMenu = signal<{ label: string; iconPath: string }>({
    label: 'Dashboard',
    iconPath: 'assets/icons/view-dashboard-outline.svg',
  });

  private _sidebarExpanded = signal(true);
  readonly mobileNavOpen = signal(false);

  get sidebarExpanded() {
    return this._sidebarExpanded();
  }

  /** Expanded labels/chrome: desktop expand, or mobile drawer open. */
  isNavChromeExpanded(): boolean {
    return this._sidebarExpanded() || this.mobileNavOpen();
  }

  public toggleSidebar() {
    this._sidebarExpanded.update((curr) => !curr);
  }

  setSidebarExpanded(expanded: boolean): void {
    this._sidebarExpanded.set(expanded);
  }

  openMobileNav(): void {
    this.mobileNavOpen.set(true);
  }

  closeMobileNav(): void {
    this.mobileNavOpen.set(false);
  }

  toggleMobileNav(): void {
    this.mobileNavOpen.update((open) => !open);
  }

  setCurrentMenu(menu: { label: string; iconPath: string }) {
    this.currentMenu.set(menu);
  }
}
